import { forwardRef } from "react";

const Input = forwardRef(({ type = "text", ...props }, ref) => (
  <input type={type} className="adai-form-input" ref={ref} {...props} />
));

export default Input;